module.exports = __webpack_public_path__ + "static/media/background.ec4cf07e.png";